<template>
  <Modal :open="isOpen" :close="handleClose">
    <div
      class="grid grid-cols-6 text-left overflow-y-auto"
      style="width: 1200px; max-height: 600px"
    >
      <div class="col-span-6 m-5">
        <div class="flex justify-end">
          <button
            type="button"
            @click="saveToFB"
            @click.stop.prevent
            :class="`${
              loading === 1 && 'animate-pulse'
            } inline-flex items-center px-4 py-2 border border-green-300 rounded-md shadow-sm text-xs font-medium text-green-700 bg-white hover:bg-green-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 `"
          >
            Save
            <IconSync
              class="ml-1 animate-spin text-green"
              v-if="loading === 1"
            />
            <IconSolidCheck v-if="loading === 2" />
          </button>
        </div>
        <div>
          <div class="grid grid-cols-6 gap-3">
            <h2 class="col-span-6 font-black text-gray-500">Edit A Gallery</h2>
            <hr class="col col-span-6" />
            <div class="col col-span-6" v-if="errors.length">
              <b>Please correct the following error(s):</b>
              <ul>
                <li
                  v-for="(error, index) in errors"
                  :key="index"
                  style="color: red"
                >
                  {{ error }}
                </li>
              </ul>
            </div>
            <div class="col col-span-4">
              <TextField
                label="Tag Name"
                placeholder="Enter tag name"
                v-model="internalGallery.tag"
              />
            </div>
            <SelectField
              class="col col-span-2"
              label="Tag Type"
              v-model="internalGallery.tag_type"
              :options="this.tagTypes"
            />
            <div class="col col-span-6">
              <TextField
                label="Featured Image"
                placeholder="Enter featured image URL or upload less than 2MB image file"
                v-model="internalGallery.featured_image"
              />
              <input
                accept="image/*"
                class="cursor-pointer border-4 border-main-300 p-2 rounded-lg mt-5 flex justify-start"
                type="file"
                @change="handleImage"
              />
            </div>
            <div class="col col-span-6">
              <label class="block text-sm font-bold text-gray-600">
                Description
              </label>
              <ckeditor
                :editor="editor"
                v-model="internalGallery.description"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { reactive } from "vue";
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Modal from "@/components/Shared/Modal/Base";
import IconSolidCheck from "@/assets/icons/IconSolidCheck";
import IconSync from "@/assets/icons/IconSync";
import TextField from "@/components/Shared/Input/TextField";
import SelectField from "@/components/Shared/Input/SelectField";
import { s3 } from "@/common/aws";

export default {
  name: "GalleryEditModal",
  components: {
    Modal,
    IconSolidCheck,
    IconSync,
    TextField,
    SelectField,
    ckeditor: CKEditor.component
  },
  props: {
    handleClose: {
      type: Function,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    gallery: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: 0,
      errors: [],
      editor: ClassicEditor
    };
  },
  computed: {
    internalGallery() {
      return reactive(Object.assign({}, this.gallery.data));
    },
    ...mapGetters(["currentUser", "tagTypes"])
  },
  watch: {
    isOpen() {
      if (!this.isOpen) {
        this.loading = 0;
        this.errors = [];
      }
    }
  },
  methods: {
    async handleImage(e) {
      if (e.target.files[0].size < 2097152) {
        let params = {
          Bucket: "shopthelook-uploads",
          Key: `${e.target.files[0].name.replace(/\s+/g, "-").toLowerCase()}`,
          Body: e.target.files[0],
          ContentType: "image/jpg",
          ContentDisposition: "inline"
        };

        this.errors = [];

        try {
          await s3.upload(params, (err, result) => {
            if (err) {
              this.errors.push("S3 Uploading ERROR: " + err.message);
            } else {
              this.internalGallery.featured_image = result.Location;
            }
          });
        } catch (error) {
          this.errors.push("S3 Uploading ERROR: " + error.message);
        }
      } else {
        this.errors.push("The size of image file should less than 2MB.");
      }
    },
    saveToFB(e) {
      if (
        this.internalGallery.tag &&
        this.internalGallery.featured_image &&
        this.internalGallery.description
      ) {
        this.loading = 1;
        const galleryData = {
          tag: this.internalGallery.tag,
          tag_type: this.internalGallery.tag_type,
          featured_image: this.internalGallery.featured_image,
          description: this.internalGallery.description,
          date_added: new Date().toJSON(),
          modified_by: `${this.currentUser.email.split("@")[0].toUpperCase()}`
        };
        this.$store
          .dispatch(Actions.FB_UPDATE_GALLERY, {
            id: this.gallery.id,
            region: "au",
            data: galleryData
          })
          .then(() =>
            setTimeout(() => {
              this.loading = 2;
            }, 900)
          );
      }

      this.errors = [];

      if (!this.internalGallery.tag) {
        this.errors.push("Tag name required.");
      }
      if (!this.internalGallery.featured_image) {
        this.errors.push("Featured image URL required.");
      }
      if (!this.internalGallery.description) {
        this.errors.push("Gallery description required.");
      }

      e.preventDefault();
    }
  }
};
</script>
